import React from 'react';
import { UserGroup } from '@round/api';
import useCheckUserGroupAccess from '../../../hooks/useCheckUserGroupAccess';
import { Navigate } from 'react-router-dom';

type ProtectedRouteProps = {
    children?: React.ReactNode | undefined;
    groups: UserGroup[];
    hasAccessWhenMatches: 'all' | 'any';
};

const ProtectedRoute = ({ children, groups, hasAccessWhenMatches }: ProtectedRouteProps) => {
    const hasAccess = useCheckUserGroupAccess(groups, hasAccessWhenMatches);
    if (typeof hasAccess !== 'boolean') {
        return null;
    }

    if (!hasAccess) {
        return <Navigate to="/unauthorised/" />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
